import React from 'react';
import { CtaBlock } from '../CtaButton';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { Accent, SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-123" data-mp="2h5my2qfpxa77">
      <div className="mx-auto max-w-6xl" data-id="element-124" data-mp="2d5mih2gvusyk">
        <SectionHeading id="inside-heading" eyebrow="See What's Inside" title={<>
              Don't Just Read About a Technique. <Accent data-id="element-126" data-mp="235m29peb8syl">Teach It Visually.</Accent>
            </>} body="Nail Educator Ready™ combines technical explanations with visual teaching resources designed to help students see the difference between correct and incorrect technique." data-id="element-125" data-mp="2d2qotqc2iqfx" />

        <div className="mt-12" data-id="element-127" data-mp="3sm3jd0dyel1z">
          <InsidePagesCarousel data-id="element-128" data-mp="3skacbjzfhytg" />
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-129" data-mp="3ok0563zwh2d0">
          This isn't a collection of generic nail ebooks. It's teaching material designed to be used
          in <Accent data-id="element-130" data-mp="28lot2nxk5u2r">real nail classes.</Accent>
        </p>

        <CtaBlock label="Get Instant Access" meta="6 Volumes • 5 Bonuses • Ready-to-Use PDFs" className="mx-auto mt-10 max-w-md" data-id="element-131" data-mp="1ule11hkii9g0" />
      </div>
    </section>;
}